<div class="d-flex pr-2">
    <div class="formattedValue" [class.minWidth]="setHigherMinWidth">{{value}}</div>
    <div class="progress-bar-container">
        <div class="progress-bar-determinate" *ngIf="hideContainer">
            <div class="progress-bar-fill" [style.min-width]="4 + 'px'"
                [style.width]="calculatedWidth + '%' "
                [style.background-color]="color"></div>
        </div>
    </div>
</div>